import { useTranslation } from 'react-i18next';
import { AppDispatch, AppStore } from '../../../store';
import { EApiType, EDataTableType, EModuleType } from '../../../data/Constants';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { joinSelectedKeys } from '../../../services/DataHelperFunctions';
import { setAlertMessage } from '../../../store/states/AlertMessageSlice';
import { useDispatch } from 'react-redux';
import { useApiError } from '../../../hooks';
import { getLanguages, deleteLanguage } from '../../../store/states/LanguageSlice';

import type { IManagementProps } from '../../../../types';

export const LanguageManagement = (props: IManagementProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.LanguageKey);

  const deleteItems = (req) => {
    const languages = AppStore.getState().dataMaintainance.languages;
    dispatch(deleteLanguage({ token: props.token, request: req })).then((res) => {
      const delKeys = joinSelectedKeys(req);
      if (res.payload?.data) {
        const message = t('messages.success.delete.languages', {
          length: req.length,
          list: delKeys,
        });
        dispatch(setAlertMessage({ show: true, message: message, type: 'success' }));
        dispatch(
          getLanguages({
            token: props.token,
            page: languages.currentPage,
            limit: languages.recordsPerPage,
            searchCode: languages.searchKey,
          })
        );
      } else {
        const message = t('messages.fail.delete.languages', { length: req.length, list: delKeys });
        dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
      }
    });
  };

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('labels.languageManagement')}</h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.Languages}
        getDataList={getLanguages}
        moduleType={EModuleType.Datamaintainance}
        deleteItems={deleteItems}
      />
    </>
  );
};
